import { AsyncInputSelect } from '@/components';
import { useNetworkGroupValueSearch } from './useNetworkGroupValueSearch';
import type { GroupId } from '@/features/types';

type SearchableGroupFilterProps = {
  groupId: GroupId;
  /** First page of values, inlined by `all_values` so the dropdown opens with content. */
  initialValues: string[];
  label: string;
  placeholder: string;
  selected: (string | null)[] | undefined;
  onChange: (values: (string | null)[]) => void;
  onBlur: (e: React.FocusEvent<HTMLInputElement>) => void;
  disabled?: boolean;
};

/**
 * Filter select for a `searchable` network group — one whose value list is too
 * large for `all_values` to inline, so values are searched and paged from the
 * backend instead.
 */
export const SearchableGroupFilter = ({
  groupId,
  initialValues,
  label,
  placeholder,
  selected,
  onChange,
  onBlur,
  disabled,
}: SearchableGroupFilterProps) => {
  const search = useNetworkGroupValueSearch(groupId, initialValues);

  return (
    <AsyncInputSelect
      label={label}
      placeholder={placeholder}
      options={search.values.map((v) => ({ label: v, value: v }))}
      value={(selected ?? [])
        .filter((v) => v !== null)
        .map((v) => ({ label: v, value: v }))}
      onChange={onChange}
      onBlur={onBlur}
      isDisabled={disabled}
      searchValue={search.searchValue}
      onSearchChange={search.onSearchChange}
      isFetching={search.isFetching}
      hasMore={search.hasMore}
      atCap={search.atCap}
      onLoadMore={search.loadMore}
      onDropdownOpen={search.ensureLoaded}
    />
  );
};
